import UpdateUserModal from './UpdateUserModal';

export default UpdateUserModal;
